module.exports = __webpack_public_path__ + "img/winnings-heading.5fd2e8d2.png";